import { render, staticRenderFns } from "./StudentMarkDataTable.vue?vue&type=template&id=3d970888&scoped=true&"
import script from "./StudentMarkDataTable.vue?vue&type=script&lang=js&"
export * from "./StudentMarkDataTable.vue?vue&type=script&lang=js&"
import style0 from "./StudentMarkDataTable.vue?vue&type=style&index=0&id=3d970888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d970888",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
